import React, { useEffect, useState, useRef } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import {
  IonContent,
  IonSkeletonText,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import WatchHeader from './WatchHeader'
import WatchFooter from './WatchFooter'
import WatchPlayer from './WatchPlayer'
import { ContentBlocks } from '../../components/content'
import { setMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import {
  getContent,
  getRelatedContents
} from '../../services/api/contents'
import './styles.scss'

const Watch = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [content, SetContent] = useState(false)
  const [related, setRelated] = useState(false)
  const { hashid, preview } = useParams()
  const [id, title] = hashid.split('_')
  const contentRef = useRef()
  const history = useHistory()

  useIonViewDidEnter(() => {
    setIsVisible(true)
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    const params = {
      id: id,
      title: title,
      section_id: 4
    }
    if (preview) {
      params.preview = preview
    }
    getContent(params)
      .then((response) => {
        SetContent(response)
        setView(window.location.pathname)
        setPixelView()
        var keywords = []
        response.header.tags.map((tag) => {
          keywords.push(tag.name)
          return keywords
        })
        setMetaTags({
          type: 'article',
          author: 'Yok Radio',
          title: `${response.header.title} - Yok Radio`,
          keywords: keywords.join(','),
          description: response.header.intro,
          image: response.header.miniature,
          'image:width': response.header.miniature_width,
          'image:height': response.header.miniature_height,
          'article:published_time': response.header.date,
          'article:section': response.header.category
        })
      })
      .catch(() => {
        SetContent(false)
        history.push('/404')
      })
    return () => {
      SetContent(false)
    }
  }, [id, title, preview])

  useEffect(() => {
    getRelatedContents({
      id: id,
      title: title,
      related: 'category'

    }).then((response) => {
      setRelated(response)
    }).catch(() => {
      setRelated(false)
    })
    return () => {
      setRelated(false)
    }
  }, [id, title])

  if (isVisible === false) return null

  if (content === false) {
    return (
      <IonContent
        ref={contentRef}
        fullscreen
        className='watch-page loading-content page-wrapper'
      >
        <div className='flexible-width-content'>
          <section className='share-container'>
            <IonSkeletonText className='share' animated />
          </section>
          <IonSkeletonText className='title' animated />
          <IonSkeletonText className='video' animated />
        </div>
      </IonContent>
    )
  } else {
    return (
      <IonContent
        ref={contentRef}
        fullscreen
        className='watch-page page-wrapper'
        itemScope itemType='http://schema.org/NewsArticle'
      >
        <div className='wrapper'>

          {content.header.id_product_source === '1' &&
            <div
              className='flexible-width-content'
            >
              <WatchHeader content={content} />

              <section
                itemProp='articleBody'
                className='Watch-body'
              >
                {content?.body && content.body.map((content, index) => {
                  return React.createElement(ContentBlocks[content.block], {
                    key: index,
                    content: content.decodedData
                  })
                })}
              </section>
            </div>}

          {content.header.id_product_source === '2' &&
            <div
              className='flexible-width-content'
            >
              <WatchPlayer content={content} />
            </div>}
        </div>

        {related &&
          <WatchFooter
            related={related}
          />}
      </IonContent>
    )
  }
}

export default Watch
